import { TransactionDirection } from '@shared/transactions-types';

import { MainCategoryName } from './MainCategories';

const mainCategoriesByDirection: Record<
    TransactionDirection.INCOMING | TransactionDirection.OUTGOING,
    MainCategoryName[]
> = {
    OUTGOING: [
        MainCategoryName.LIVING_AND_ENERGY,
        MainCategoryName.FOOD,
        MainCategoryName.HEALTH,
        MainCategoryName.CLOTHING,
        MainCategoryName.COMMUNICATION,
        MainCategoryName.LEISURE,
        MainCategoryName.EDUCATION,
        MainCategoryName.CAR,
        MainCategoryName.TRANSPORT,
        MainCategoryName.TRAVEL_HOLIDAYS,
        MainCategoryName.WITHDRAWAL,
        MainCategoryName.ALIMONY_POCKET_MONEY,
        MainCategoryName.ONLINE_SHOPPING,
        MainCategoryName.SAVINGS_INVESTMENT,
        MainCategoryName.TAXES,
        MainCategoryName.FEES,
        MainCategoryName.OTHER_EXPENSES,
        MainCategoryName.UNCATEGORIZED_EXPENSE,
    ],
    INCOMING: [
        MainCategoryName.REGULAR_INCOME,
        MainCategoryName.NON_REGULAR_INCOME,
        MainCategoryName.UNCATEGORIZED_INCOME,
    ],
};

export const getMainCategoriesByTransactionDirection = (
    txDirection: TransactionDirection,
): MainCategoryName[] => {
    switch (txDirection) {
        case TransactionDirection.INCOMING:
            return mainCategoriesByDirection.INCOMING;
        case TransactionDirection.OUTGOING:
            return mainCategoriesByDirection.OUTGOING;
        case TransactionDirection.ALL:
            return [...mainCategoriesByDirection.OUTGOING, ...mainCategoriesByDirection.INCOMING];
        default:
            return [];
    }
};
